import { bindAuthQueryClient } from '@repo/ui/libs/authQueryBoundary'
import { useAuthStore } from '@repo/ui/stores/auth.store'
document.documentElement.classList.add('streamer-theme')
import '@fontsource-variable/geist'
import '@fontsource-variable/geist-mono'
import './assets/main.css'

import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'
import { createHead } from '@unhead/vue/client'
import { createApp } from 'vue'
import { appIconOverridesKey, clientEnv, createBetterAuthClient, setAuthClient } from '@repo/ui'
import { streamerIcons } from './icons'

import App from './App.vue'
import { listenForWebAppInstall } from './composables/useWebAppInstall'
import i18n from './i18n'
import { pinia } from './pinia'
import router from './router'

const authClient = createBetterAuthClient(clientEnv.VITE_AUTH_API_URL)
setAuthClient(authClient, clientEnv.VITE_AUTH_API_URL)

listenForWebAppInstall()
const app = createApp(App)
app.provide(appIconOverridesKey, streamerIcons)
const head = createHead()

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(head)
const queryClient = new QueryClient()
bindAuthQueryClient(queryClient, useAuthStore(pinia))
app.use(VueQueryPlugin, { queryClient })

app.mount('#app')
